<template>
  <div
    ref="style"
    class="icon__wrapper"
    :tabindex="selected ? 0 : -1"
    :style="{ backgroundColor: selected ? 'lightblue' : 'transparent' }"
  >
    <svg id="table" width="60" height="50">
      <!-- Define row height and column width -->
      <rect id="row1" x="0" y="0" width="60" height="10" :fill="rowColors.row1"></rect>
      <rect id="row2" x="0" y="10" width="60" height="10" :fill="rowColors.row2"></rect>
      <rect id="row3" x="0" y="20" width="60" height="10" :fill="rowColors.row3"></rect>
      <rect id="row4" x="0" y="30" width="60" height="10" :fill="rowColors.row4"></rect>
      <rect id="row5" x="0" y="40" width="60" height="10" :fill="rowColors.row5"></rect>

      <!-- Content for each cell (small horizontal lines) -->
      <!-- Row 1 -->
      <g :class="['row-content', rowContentClasses.row1]">
        <line x1="2" y1="5" x2="10" y2="5" />
        <line x1="14" y1="5" x2="22" y2="5" />
        <line x1="26" y1="5" x2="34" y2="5" />
        <line x1="38" y1="5" x2="46" y2="5" />
        <line x1="50" y1="5" x2="58" y2="5" />
      </g>

      <!-- Row 2 -->
      <g :class="['row-content', rowContentClasses.row2]">
        <line x1="2" y1="15" x2="10" y2="15" />
        <line x1="14" y1="15" x2="22" y2="15" />
        <line x1="26" y1="15" x2="34" y2="15" />
        <line x1="38" y1="15" x2="46" y2="15" />
        <line x1="50" y1="15" x2="58" y2="15" />
      </g>

      <!-- Row 3 -->
      <g :class="['row-content', rowContentClasses.row3]">
        <line x1="2" y1="25" x2="10" y2="25" />
        <line x1="14" y1="25" x2="22" y2="25" />
        <line x1="26" y1="25" x2="34" y2="25" />
        <line x1="38" y1="25" x2="46" y2="25" />
        <line x1="50" y1="25" x2="58" y2="25" />
      </g>

      <!-- Row 4 -->
      <g :class="['row-content', rowContentClasses.row4]">
        <line x1="2" y1="35" x2="10" y2="35" />
        <line x1="14" y1="35" x2="22" y2="35" />
        <line x1="26" y1="35" x2="34" y2="35" />
        <line x1="38" y1="35" x2="46" y2="35" />
        <line x1="50" y1="35" x2="58" y2="35" />
      </g>

      <!-- Row 5 -->
      <g :class="['row-content', rowContentClasses.row5]">
        <line x1="2" y1="45" x2="10" y2="45" />
        <line x1="14" y1="45" x2="22" y2="45" />
        <line x1="26" y1="45" x2="34" y2="45" />
        <line x1="38" y1="45" x2="46" y2="45" />
        <line x1="50" y1="45" x2="58" y2="45" />
      </g>
    </svg>
  </div>
</template>

<script>
import { stylePatterns } from "../../utils/util";
export default {
  props: ["styleId", "selected"],
  data() {
    return {
      rowColors: {
        row1: "#e6f7ff",
        row2: "#f0f0f0",
        row3: "#e6f7ff",
        row4: "#f0f0f0",
        row5: "#e6f7ff",
      },
      rowContentClasses: {
        row1: "",
        row2: "",
        row3: "",
        row4: "",
        row5: "",
      },
      currentRowIndex: 0,
    };
  },
  mounted() {
    const style = stylePatterns[this.styleId];
    this.rowColors.row1 = style[0].bgColor;
    this.rowColors.row2 = style[1].bgColor;
    this.rowColors.row3 = style[0].bgColor;
    this.rowColors.row4 = style[1].bgColor;
    this.rowColors.row5 = style[0].bgColor;
  },
  methods: {
    changeRowBackgroundColor(rowId, color) {
      this.rowColors[rowId] = color;
    },
    changeRowContentClass(rowId, newClass) {
      this.rowContentClasses[rowId] = newClass;
    },
  },
};
</script>

<style scoped lang="less">
.icon {
  &__wrapper {
    display: grid;
    align-items: center;
    justify-items: center;
    padding: 2px;
    border: none;
    outline: none;
  }
}

svg {
  border-radius: 2px;
  width: 100%;
  background-color: #f9f9f9;
  zoom: 1.6;
}

/* Default line color */
.row-content line {
  stroke: black;
  stroke-width: 1;
}
</style>
